'use client'

import * as React from 'react'
import styled from 'styled-components'
import { createContainer } from 'unstated-next'

function useStickyAddToBagRefs() {
  const pageBottomRef = React.useRef<HTMLDivElement>(null)

  // Reference to scrollable area to determine how much it has scrolled once open, and scroll-to-top on close. Kyle Corbelli 11/12/19
  const detailsCardScrollableAreaRef = React.useRef<HTMLDivElement>(null)

  // Reference to add-to-bag section to determine if we should display the sticky add-to-bag. Kyle Corbelli 01/08/20
  const detailsSectionAddToBagSectionRef = React.useRef<HTMLDivElement>(null)

  return {
    detailsSectionAddToBagSectionRef,
    detailsCardScrollableAreaRef,
    pageBottomRef,
  }
}

export const StickyAddToBagRefsContainer = createContainer(useStickyAddToBagRefs)
export const StickyAddToBagRefsProvider = ({ children }: { children: React.ReactNode }) => (
  <StickyAddToBagRefsContainer.Provider>{children}</StickyAddToBagRefsContainer.Provider>
)

export const PageBottomDivForIntersections = styled.div``
export const BottomOfPageMarkerForStickyAddToBag = () => {
  const { pageBottomRef } = StickyAddToBagRefsContainer.useContainer()
  return <PageBottomDivForIntersections ref={pageBottomRef} />
}
